import { fetcher } from '../../../lib/api-fetcher';


export interface MaintenanceState {
  enabled: boolean;
  message: string;
  updatedAt: string;
  allowedRoles?: string[];
}

export interface BackupFile {
  filename: string;
  sizeBytes: number;
  createdAt: string;
}

export function getMaintenanceStatus() {
  return fetcher.get<MaintenanceState>('/admin/maintenance');
}

export function toggleMaintenance(body: { enabled: boolean; message?: string; allowedRoles?: string[] }) {
  return fetcher.post<MaintenanceState>('/admin/maintenance', body);
}

export function getBackupsList() {
  return fetcher.get<BackupFile[]>('/admin/maintenance/backups');
}

export function triggerBackup() {
  return fetcher.post<{ message: string }>('/admin/maintenance/backups/trigger', {});
}

export interface EffectiveRetentionConfig {
  companyId: string;
  notifications: number;
  auditLog: number;
  customerDocuments: number;
  isCustom: boolean;
}

export interface UpdateRetentionConfigInput {
  notifications?: number;
  auditLog?: number;
  customerDocuments?: number;
}

export function getRetentionConfig() {
  return fetcher.get<{ data: EffectiveRetentionConfig }>('/staff/v1/admin/retention-config');
}

export function updateRetentionConfig(body: UpdateRetentionConfigInput) {
  return fetcher.put<{ data: EffectiveRetentionConfig }>('/staff/v1/admin/retention-config', body);
}

export function triggerRetentionPurge() {
  return fetcher.post<{ data: { purgedCount: number } }>('/staff/v1/admin/retention-config/run', {});
}


